import { colors } from '#/src/colors';
import { styled } from '#/src/theme';

export const Spacer = styled('div')({
  height: '4px',
  width: '30px',
  borderRadius: '2px',
  backgroundColor: colors.brandGreen,
  margin: '20px',
});
